import type { NavSection } from '../core/models/nav-section.model';

/**
 * Navigation Sections Configuration
 * Defines the 6-domain sidebar navigation structure.
 *
 * Icons use Remix Icon class names (ri-*).
 * Reference: gozem-webapp SIDEBAR_SECTIONS
 *
 * Sections:
 *  1. Général     — core daily-use features
 *  2. E-commerce  — online store management
 *  3. Paiements   — client & invoice management
 *  4. Mobilité    — ride & driver operations
 *  5. Développeur — API & integration tooling
 *  6. Paramètres  — account & app settings
 */
export const NAV_SECTIONS: NavSection[] = [
  // ─── 1. Général ─────────────────────────────────────────────────────────────
  {
    id: 'general',
    label: 'Général',
    items: [
      {
        id: 'wallet',
        label: 'Portefeuille',
        icon: 'ri-wallet-3-line',
        route: '/wallet',
      },
      {
        id: 'transactions',
        label: 'Transactions',
        icon: 'ri-exchange-line',
        route: '/transactions',
      },
    ],
  },

  // ─── 2. E-commerce ──────────────────────────────────────────────────────────
  // {
  //   id: 'ecommerce',
  //   label: 'Ecommerce',
  //   items: [
  //     {
  //       id: 'products',
  //       label: 'Produits',
  //       icon: 'ri-box-3-line',
  //       route: '/ecommerce/products',
  //     },
  //     {
  //       id: 'orders',
  //       label: 'Commandes',
  //       icon: 'ri-file-list-3-line',
  //       route: '/ecommerce/orders',
  //       badge: 'Bêta',
  //       badgeClass: 'bg-amber-100 text-amber-700',
  //     },
  //     {
  //       id: 'deliveries',
  //       label: 'Livraisons',
  //       icon: 'ri-arrow-go-back-line',
  //       route: '/ecommerce/deliveries',
  //     },
  //     {
  //       id: 'reviews',
  //       label: 'Avis',
  //       icon: 'ri-star-line',
  //       route: '/ecommerce/reviews',
  //     },
  //   ],
  // },

  // ─── 3. Paiements ───────────────────────────────────────────────────────────
  // {
  //   id: 'payments',
  //   label: 'Paiements',
  //   items: [
  //     {
  //       id: 'clients',
  //       label: 'Clients',
  //       icon: 'ri-group-line',
  //       route: '/payments/clients',
  //     },
  //     {
  //       id: 'invoices',
  //       label: 'Factures',
  //       icon: 'ri-bill-line',
  //       route: '/payments/invoices',
  //     },
  //     {
  //       id: 'payment-links',
  //       label: 'Liens de paiement',
  //       icon: 'ri-bank-card-line',
  //       route: '/payments/links',
  //     },
  //     {
  //       id: 'subscriptions',
  //       label: 'Abonnements',
  //       icon: 'ri-repeat-line',
  //       route: '/payments/subscriptions',
  //     },
  //   ],
  // },

  // ─── 4. Mobilité ────────────────────────────────────────────────────────────
  // {
  //   id: 'mobility',
  //   label: 'Mobilité',
  //   items: [
  //     {
  //       id: 'courier',
  //       label: 'Courses',
  //       icon: 'ri-riding-line',
  //       route: '/mobility/courses',
  //     },
  //     {
  //       id: 'dispatcher',
  //       label: 'Dispatcher',
  //       icon: 'ri-road-map-line',
  //       route: '/mobility/dispatcher',
  //     },
  //     {
  //       id: 'trips',
  //       label: 'Historique des trajets',
  //       icon: 'ri-route-line',
  //       route: '/mobility/trips',
  //     },
  //     {
  //       id: 'corporate',
  //       label: 'Groupes corporatifs',
  //       icon: 'ri-building-2-line',
  //       route: '/mobility/corporate',
  //     },
  //     {
  //       id: 'users',
  //       label: 'Utilisateurs',
  //       icon: 'ri-user-3-line',
  //       route: '/mobility/users',
  //     },
  //   ],
  // },

  // ─── 5. Développeur ─────────────────────────────────────────────────────────
  // {
  //   id: 'developer',
  //   label: 'Développeur',
  //   items: [
  //     {
  //       id: 'api-clients',
  //       label: 'API Clients',
  //       icon: 'ri-terminal-box-line',
  //       route: '/developer/api-clients',
  //     },
  //     {
  //       id: 'webhooks',
  //       label: 'Webhooks',
  //       icon: 'ri-webhook-line',
  //       route: '/developer/webhooks',
  //     },
  //     {
  //       id: 'analytics',
  //       label: 'Analytics',
  //       icon: 'ri-bar-chart-box-line',
  //       route: '/developer/analytics',
  //     },
  //     {
  //       id: 'docs',
  //       label: 'Documentation',
  //       icon: 'ri-book-open-line',
  //       route: '/developer/docs',
  //     },
  //     {
  //       id: 'api-console',
  //       label: 'API Console',
  //       icon: 'ri-code-s-slash-line',
  //       route: '/developer/api-console',
  //     },
  //     {
  //       id: 'logs',
  //       label: 'Logs',
  //       icon: 'ri-file-text-line',
  //       route: '/developer/logs',
  //     },
  //   ],
  // },

  // ─── 6. Paramètres ──────────────────────────────────────────────────────────
  {
    id: 'settings',
    label: 'Paramètres',
    items: [
      {
        id: 'settings',
        label: 'Paramètres',
        icon: 'ri-settings-3-line',
        route: '/settings',
      },
    ],
  },
  // NOTE: 'Membres de l'équipe', 'Facturation' and a dedicated '/settings/general'
  // sub-page are not yet implemented — only '/settings' (account settings, incl.
  // "Récupérer mon code de sécurité") exists today. Re-add those items once their
  // pages are built to avoid linking to 404s.
];
